import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { typography, fontWeights } from '../../../styles/typography';
import { MediaQueries } from '../../../styles/Grid';
import createButtonCss from '../../ui/Button/Button';

export const containerMargin = css({
  marginTop: 40,
  marginBottom: 40,
  [MediaQueries.mdAndUp]: {
    marginTop: 96,
    marginBottom: 96,
  },
});

export const containerPadding = css({
  paddingTop: 40,
  paddingBottom: 40,
  [MediaQueries.mdAndUp]: {
    paddingTop: 96,
    paddingBottom: 96,
  },
});

export const headline = css(typography.effra40, {
  fontWeight: fontWeights.medium,
  marginBottom: 16,
  [MediaQueries.mdAndUp]: {
    fontSize: 58,
    lineHeight: 1,
  },
});

export const subheadline = css(typography.effra16, {
  color: colorsPalette.grey80,
  marginBottom: 24,
  [MediaQueries.mdAndUp]: {
    marginBottom: 32,
  },
});

export const inputCommon = css({
  marginBottom: 16,
});

export const inputCssProps = {
  customLabelCss: css({
    fontSize: 16,
  }),
  customContainerCss: css({
    height: 56,
    paddingTop: 17,
  }),
  customFieldCss: css({
    fontSize: 16,
  }),
};

export const selectCssProps = {
  customPlaceholderCss: css({
    fontSize: 16,
  }),
  customLabelCss: css({
    fontSize: 16,
    minHeight: 56,
    paddingTop: 17,
  }),
};

export const phoneNumberFieldCssProps = {
  container: {
    minHeight: 56,
    padding: '13px 16px',
    '&[data-shrink="true"]': {
      padding: '13px 16px',
    },
  },
  placeholder: {
    position: 'absolute',
    top: 4,
  },
  dialingCode: {
    fontSize: 16,
  },
  inputValue: {
    fontSize: 16,
  },
  input: {
    fontSize: 16,
  },
};

export const checkboxCss = css({
  marginTop: 5,
  fontSize: 16,
  lineHeight: 1.5,
  [MediaQueries.mdAndUp]: {
    marginTop: 14,
  },
});

export const privacyContainer = css({
  marginTop: 33,
  fontSize: 16,
  lineHeight: 1.5,
  [MediaQueries.mdAndUp]: {
    marginTop: 17,
  },
});

export const privacyLabel = css({
  paddingRight: 10,
});

export const privacyPolicyLink = css({
  fontSize: 16,
  lineHeight: 1.5,
});

export const submitButton = css(createButtonCss(), {});

export const submitButtonSent = css({
  ':disabled': {
    backgroundColor: colorsPalette.red120,
  },
});

export const submitButtonLoading = css({
  height: 56,
  paddingTop: 0,
  paddingBottom: 0,
  ':disabled': {
    backgroundColor: colorsPalette.red,
  },
});

export const submitButtonIcon = css({
  fontSize: 10,
  marginRight: 10,
});

export const notificationContainer = css({
  marginTop: 24,
  marginBottom: 24,
});

export const notification = css({
  padding: '15px 20px 15px 55px',
  border: `1px solid ${colorsPalette.brown40}`,
  borderRadius: 2,
  fontSize: 14,
  lineHeight: 1.71,
  position: 'relative',
  [MediaQueries.mdAndUp]: {
    display: 'inline-block',
    minWidth: 'calc(50% - 16px)',
  },
});

export const notificationError = css({
  borderColor: colorsPalette.red120,
  color: colorsPalette.red120,
});

export const badge = css({
  position: 'absolute',
  marginTop: 2,
  display: 'inline-block',
  width: 18,
  height: 18,
  fontSize: 18,
  borderRadius: '50%',
  left: 20,
});

export const badgeSuccess = css({
  color: colorsPalette.teal,
});
